import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { DesignPatternStudioProvider, useDesignPatternStudio } from '../DesignPatternStudioContext';
import { useTexture } from '../../Shared/TextureContext';
import Studio from '../Builder';
import EditConfig from '../EditConfig';
import DesignReviewView from '../Preview';

const StudioWrapper = ({ match }) => {
  const { state } = useDesignPatternStudio();
  const { fetchTextureImages, textures } = useTexture();
  
  useEffect(() => {
    // Load band textures by default, or sleeve textures if inside pattern is enabled
    const textureType = state.insideFeature ? 'sleeve' : 'band';
    if(!textures[textureType]) {
      fetchTextureImages(textureType);
    }
  }, [fetchTextureImages, state.insideFeature, textures]);

  return (
    <Switch>
      <Route exact path={match.path} component={Studio} />
      <Route path={`${match.path}/edit-config`} component={EditConfig} />
      <Route path={`${match.path}/review`} component={DesignReviewView} />
    </Switch>
  );
};

const DesignPatternStudio = ({ match }) => {
  return (
    <DesignPatternStudioProvider>
      <StudioWrapper match={match} />
    </DesignPatternStudioProvider>
  );
};

export default DesignPatternStudio;